<template>
  <div class="agreement_page">
    <div class="agreement_title">{{info.title}}</div>
    <div class="agreement_content" v-html="info.content"></div>
    <!-- <h1>隐私协议</h1>
    <div class="content">
        <dev class="f-w f-16">一、总则</dev>
        <p>{{ name }}（以下或称“我们”）尊重并保护您的隐私，您通过计算机设备、移动终端或其他设备使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本隐私协议（以下简称“本政策”）向您说明，如您页面浏览/注册并登陆我们的官方网站(网址：www.motortime.com)及APP“{{ name }}”，并使用我们在上述平台的全部服务时，我们可能会收集您的哪些信息并如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、控制和保护这些信息的方式。本政策与您使用我们的服务关系紧密，我们建议您仔细阅读并理解本政策全部内容，做出您认为适当的选择。请注意我们不时地会检查我们的政策，因此有关的措施会随之变化。我们恳请您定期光顾本页面，以确保对我们《隐私协议》最新版本始终保持了解。
        </p>
        <p>您使用或继续使用我们的服务，即意味着同意我们按照本政策收集、使用、储存和分享您的相关信息。</p>
        <p>如您有关于网络信息安全的投诉和举报，或您对本《隐私协议》、您的信息的相关事宜有任何问题、意见或建议，以及有关本声明或{{ name }}的隐私措施的问题请与我们联系（联系邮箱：kefu@motortime.com
            ，联系电话：010-84425181），我们会在收到您的反馈的【30】天内进行回复。</p>
        <p>本隐私协议部分将帮助您了解以下内容，其中，有关您个人信息权益的重要条款我们已用加粗形式提示，请特别关注：</p>
        <p>1.我们如何收集和使用个人信息</p>
        <p>2.我们如何使用cookie等同类技术</p>
        <p>3.我们如何分享、转让、公开披露个人信息</p>
        <p>4.我们如何存储个人信息</p>
        <p>5.我们如何保护个人信息的安全</p>
        <p>6.您如何管理个人信息</p>
        <p>7.未成年人信息保护的特别约定</p>
        <p>8.修订和通知</p>
        <p>9.联系我们</p>
        <p>我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
        </p>
        <p>请在使用我们的产品(或服务)前，仔细阅读并了解本《隐私协议》。</p>
        <p>一.我们如何收集和使用个人信息</p>
        <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
        <p>我们会按照如下方式收集您在使用我们服务时主动提供的，以及通过自动化手段收集您在接受服务或使用功能过程中产生的信息：</p>
        <p>1.1 为您提供网上购车的服务</p>
        <p>1.1.1 业务功能一：注册成为用户</p>
        <p>a. 注册、登录</p>
        <p>当您注册、登录{{ name }}及相关服务时，您可以通过手机号创建账号，并且您可以完善相关的网络身份识别信息（头像、昵称、密码、所在地、个人签名），收集这些信息是为了帮助您完成注册。您还可以根据自身需求选择填写性别、生日来完善您的信息。
        </p>
        <p>您也可以使用第三方账号登录并使用，您将授权我们获取您在第三方平台注册的公开信息（头像、昵称以及您授权的其他信息），用于与{{ name }}账号绑定，使您可以直接登录并使用{{ name }}产品及相关服务。
        </p>
        <p>b. 认证</p>
        <p>在您使用身份认证的功能或服务时，根据相关法律法规，您可能需要提供您的真实身份信息（真实姓名、身份证号码、电话号码）以完成实名验证。
            这些信息属于个人敏感信息，您可以拒绝提供，但您可能无法使用相关功能或获得相关服务，但不影响您正常使用其他功能与服务。</p>
        <p>1.1.2 业务功能二：个性化推荐</p>
        <p>a.{{ name }}可能会向您推荐更感兴趣的信息，为提供此类服务，我们可能会收集必要的日志信息。</p>
        <p>b.用于信息展示的日志信息包括：</p>
        <p>您操作、使用的行为信息：点击、关注、收藏、搜索、浏览、分享</p>
        <p>您主动提供的信息：反馈、发布、点赞、评论</p>
        <p>地理位置信息：GPS信息、WLAN接入点</p>
        <p>GPS地理位置是个人敏感信息，若您拒绝提供，我们将不会根据GPS信息向您推荐信息，且不影响{{ name }}其他功能的正常使用。</p>
        <p>c.我们会基于IP地址对应的城市向您展示、推荐您所在地区的本地相关信息。</p>
        <p>我们对收集、使用的上述信息进行了去标识化的处理，数据分析仅对应无法直接关联您身份的、特定的编码，不会与您的真实身份相关联。</p>
        <p>1.1.3 业务功能三：搜索</p>
        <p>您使用“{{ name }}”的搜索服务时，我们会收集您的搜索关键字信息、日志记录。为了提供高效的搜索服务，部分前述信息会暂时存储在您的本地存储设备之中，并可向您展示搜索结果内容、搜索历史记录。
        </p>
        <p>1.1.4 业务功能四：提交订单</p>
        <p>您在使用获取底价业务时，我们收集的个人信息包括您的姓名、手机号码、您在软件的表格上输入的其他信息（电子邮箱、车牌号、住址等）。</p>
        <p>1.2 为您提供发布与互动的服务</p>
        <p>注册、登陆及搜索等业务功能同1.1条。</p>
        <p>1.2.1 业务功能一：发布信息</p>
        <p>a.您发布内容、评论、提问或回答时，我们将收集您发布的信息，并展示您的昵称、头像、发布内容。</p>
        <p>b.您使用上传图片、发布音视频功能时，我们会请求您授权相机、相册、麦克风权限。您如果拒绝提供此类授权，将无法使用此功能，但不影响您正常使用{{ name }}的其他功能。</p>
        <p>c.您发布信息并选择显示位置时，我们会请求您授权地理位置权限，并收集与本服务相关的位置信息。您如果拒绝授权提供精确地理位置信息，将无法使用此功能，但不影响您正常使用{{ name }}的其他功能。
        </p>
        <p>1.2.2 业务功能二：互动交流</p>
        <p>您关注感兴趣的账号、圈子并与之互动，进行浏览、收藏、评论、点赞或分享内容时，我们会收集您关注的账号，并向您展示您关注账号发布的内容、信息。</p>
        <p>1.3 为您提供广告的服务</p>
        <p>我们可能使用您的相关信息，向您提供与您更加相关的广告。我们也可能使用您的信息，通过我们的服务、电子邮件或其他方式向您发送营销信息，提供或推广我们或第三方的如下商品和服务：</p>
        <p>我们的商品或服务，我们的关联方和合作伙伴的商品或服务，包括即时通讯服务、网上媒体服务、互动娱乐服务、社交网络服务、付款服务、互联网搜索服务、位置和地图服务、应用软件和服务、数据管理软件和服务、网上广告服务、互联网金融，以及其他社交媒体、娱乐、电子商务、资讯和通讯软件或服务（统称“互联网服务”）；
        </p>
        <p>第三方互联网服务供应商，以及与下列有关的第三方商品或服务：食物和餐饮、体育、音乐、电影、电视、现场表演及其他艺术和娱乐、书册、杂志和其他刊物、服装和配饰、珠宝、化妆品、个人健康和卫生、电子、收藏品、家用器皿、电器、家居装饰和摆设、宠物、汽车、酒店、交通和旅游、银行、保险及其他金融服务、会员积分和奖励计划，以及我们认为可能与您相关的其他商品或服务。
        </p>
        <p>如您不希望我们将您的个人信息用作前述广告用途，您可以通过我们在广告中提供的相关提示，或在特定服务中提供的指引，要求我们停止为上述用途使用您的个人信息。</p>
        <p>1.4 为您提供汽车金融的服务</p>
        <p>注册、登陆及个性化推荐、搜索、提交订单等业务功能同1.1条。</p>
        <p>您在使用金融服务时，可能需要您提供姓名、性别、生日、身份证、护照、车牌号、行驶证、驾驶证、银行卡、手机号码、位置信息、地址、邮箱、浏览记录、生物特征（面部）、物流信息用来向您提供更好的产品、服务，优化并丰富您的用户体验，这些信息均是您自愿提供，您有权拒绝提供，如果您拒绝提供某些个人信息，您可能无法使用我们提供的全部或部分的产品、服务，或者可能对您使用产品或服务造成一定的影响。
        </p>
        <p>1.5 为您提供用车服务工具的服务</p>
        <p>注册、登陆及个性化推荐、搜索、提交订单等业务功能同1.1条。</p>
        <p>您在使用用车服务工具时，我们可能会收集您的姓名、车牌号、行驶证、驾驶证、手机号码，用于向您提供相应的服务。</p>
        <p>您有权拒绝提供上述信息，但可能无法使用我们提供的用车服务的产品、服务，或者可能对您使用产品或服务造成一定的影响。但不影响您正常使用{{ name }}的其他功能。</p>
        <p>1.6 为您提供安全运行的服务</p>
        <p>1.6.1 业务功能一：安全保障功能</p>
        <p>为您提供优质、可靠的产品及服务是{{ name }}的核心目标，我们致力于为您提供安全、可信赖的产品及使用环境。我们为实现安全保障功能所收集的信息为必要信息。</p>
        <p>1.6.2 业务功能二：设备与日志信息</p>
        <p>为了保障软件产品与服务的安全运行，我们希望收集以下信息：<p>
        <p>设备或软件信息：这将帮助我们了解您正在使用的设备或软件的类型和版本。</p>
        <p>移动设备所用的版本：这将帮助我们了解您正在使用的移动设备的类型和版本。</p>
        <p>硬件型号：这将帮助我们了解您设备的具体型号。</p>
        <p>设备品牌：这将帮助我们了解您设备所属的品牌。</p>
        <p>设备型号：这将帮助我们了解您设备的具体型号。</p>
        <p>屏幕分辨率：这将帮助我们了解您设备的屏幕分辨率，以便优化我们的服务。</p>
        <p>MAC地址：这将帮助我们了解您的设备的网络地址，以便为您提供网络服务。</p>
        <p>网络类型：这将帮助我们了解您当前的网络连接类型。</p>
        <p>设备唯一识别码：这将帮助我们唯一地识别您的设备。</p>
        <p>OAID：这可以帮助我们了解您的设备是否已经注册了我们的服务。</p>
        <p>IMEI：这将帮助我们了解您的设备的国际移动设备身份码。</p>
        <p>位置：这将帮助我们了解您当前的位置，以便为您提供更本地化的服务。</p>
        <p>MAC 地址：这将帮助我们了解您的设备的网络地址，以便为您提供网络服务。</p>
        <p>ANDROID-ID：这将帮助我们了解您的安卓设备的唯一标识符。</p>
        <p>IMSI：这将帮助我们了解您的国际移动用户识别码，用于识别您的移动设备用户。</p>
        <p>ICCID：这将帮助我们了解您的集成电路卡识别码，用于识别您的SIM卡。</p>
        <p>硬件序列号：这将帮助我们了解您设备的序列号。</p>
        <p>IDFA：这将帮助我们了解您的设备的广告标识符。</p>
        <p>OPENUDID：这将帮助我们了解您的设备的开放唯一标识符。</p>
        <p>IDFV：这将帮助我们了解您的设备的标识符，用于标识您的设备。</p>
        <p>SIM卡IMSI信息：这将帮助我们获取您的SIM卡的国际移动用户识别码，用于识别您的移动设备用户。</p>
        <p>操作系统版本号：这将帮助我们知道您的操作系统的版本信息。</p>
        <p>网络运营商信息：这将帮助我们知道您使用的网络运营商的信息。</p>
        <p>IP地址：这将帮助我们了解您的互联网协议地址，以便为您提供网络服务。</p>
        <p>操作使用日志：这将帮助我们了解您如何使用我们的服务，以便我们可以改进我们的产品体验。</p>
        <p>除上述用途外，您的个人信息还将有助于：</p>
        <p>1.帮助我们设计新服务，改善我们现有服务；</p>
        <p>2.使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；</p>
        <p>3.在取得您同意的情况下，向您提供与您更加相关的广告以替代普遍投放的广告；</p>
        <p>4.评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；</p>
        <p>5.软件认证或管理软件升级；</p>
        <p>6.让您参与有关我们产品和服务的调查。</p>
        <p>1.7 收集、使用个人信息目的的变更</p>
        <p>为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。若我们拟将信息用于其他用途，或者将基于特定目的收集而来的信息用于其他目的时，我们将向您告知并重新征得您的同意。
        </p>
        <p>1.8 例外情形</p>
        <p>您充分知晓，以下情形中，我们搜集并使用个人信息无需征得您的授权同意：</p>
        <p>(1)与国家安全、国防安全有关的；</p>
        <p>(2)与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>(3)与犯罪侦查、起诉、审判和判决执行等有关的；</p>
        <p>(4)所收集的个人信息是您自行向社会公众公开的；</p>
        <p>(5)从合法公开披露的信息中收集个人信息，如合法的新闻报道、政府信息公开等渠道；</p>
        <p>(6)出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
        <p>(7)根据您的要求{{ name }}为您提供服务所必需的；</p>
        <p>(8)用于维护服务的安全和合规所必需的，例如发现、处置产品和服务的故障；</p>
        <p>(9)法律法规规定的其他情形。</p>
        <p>特别提请您注意，如某些信息无法单独或结合其他信息识别到您的个人真实身份，其不属于法律意义上您的个人信息。当您的信息可以单独或结合其他信息识别出您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与您的其他个人信息结合使用时，这些信息在结合使用期间，我们将按照本隐私协议处理与保护您的此类个人信息。
        </p>
        <p>某些个人信息因其特殊性可能被认为是个人敏感信息，例如您的种族、宗教、个人健康和医疗信息等以及身份证明文件、个人生物识别信息、财产信息、行踪轨迹、未成年人的信息等，属于GB/T
            35273-2017《信息安全技术个人信息安全规范》中规定的敏感个人信息。相比其他个人信息，敏感个人信息受到更加严格的保护。请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。您同意您的敏感信息按本《隐私协议》所述的目的和方式来处理。
        </p>
        <dev class="f-w f-16">二. 我们如何使用cookie等同类技术</dev>
        <p>2.1 为确保网站正常运转、为您获得更轻松的访问体验、并向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为 Cookie的数据文件。Cookie
            通常包含标识符、站点名称以及一些号码和字符。我们向您发送Cookie是为了简化您重复登录的步骤，帮助判断您的登录状态以及账户或数据安全。</p>
        <p>2.2 我们不会将 Cookie 用于本隐私协议所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookies。有关详情，请参见
            AboutCookies.org。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookies
            的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置，而且您之前所记录的相应信息也会被删除，并且可能会对您所使用服务的安全性有一定影响。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。
        </p>
        <dev class="f-w f-16">三. 我们如何分享、转让、公开披露个人信息</dev>
        <p>3.1 我们可能分享的信息</p>
        <p>3.1.1
            出于业务运营需求，我们以及我们的关联方，可能将本隐私协议第一条中所涉及的您的个人信息与我们的关联方、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：
        </p>
        <p>(1)向您提供我们的服务；</p>
        <p>(2)实现“我们如何使用信息”部分所述目的；</p>
        <p>(3)履行我们在《{{ name }}用户服务使用协议》或本《隐私协议》中的义务或行使我们的权利；</p>
        <p>(4)理解、维护和改善我们的服务;</p>
        <p>(5)我们向相关汽车经销商、厂商及集团分享并由其在合法正当的范围内使用；</p>
        <p>(6)我们及关联公司及相关汽车经销商、厂商及集团为满足您的需求，可能通过您提供的信息与您联系。</p>
        <p>我们及关联公司及相关汽车经销商、厂商及集团可能定期或不定期向您发送有关产品、服务或相关活动的信息，您同意接收上述信息。</p>
        <p>如我们或我们的关联方与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私协议》及我们要求其遵守的其他适当的保密和安全措施，此类分享将不会对您产生高危风险。
        </p>
        <p>3.2 转让</p>
        <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
        <p>(1)事先获得您的明确同意；</p>
        <p>(2)根据法律法规或强制性的行政或司法要求；</p>
        <p>(3)在涉及资产转让、收购、兼并、重组或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的机构继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
        </p>
        <p>3.3 披露</p>
        <p>我们会在以下情况下公开披露您的个人信息：</p>
        <p>(1)根据您的需求，以您明确同意的披露方式披露您所指定的个人信息；</p>
        <p>(2)我们可能对您的信息和数据进行综合统计，并以{{ name }}判断合理的目的和用途将该综合统计向广告主披露。但是，在这些情况下，我们不会向这些机构披露任何可能用以识别用户的个人身份的资料，但从用户的用户名或其它可披露资料分析得出的资料不受此限。
        </p>
        <p>(3)根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。</p>
        <p>3.4 依法豁免征得同意分享、转让、公开披露的个人信息</p>
        <p>我们或我们的关联方还可能根据法律法规及国家标准，在下列情形中分享、转让、公开披露您的个人信息，请您理解，如下情形无需征得您的授权同意：</p>
        <p>a.与国家安全、国防安全直接相关的；</p>
        <p>b.与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>c.与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
        <p>d.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
        <p>e.您自行向社会公众公开的个人信息；</p>
        <p>f.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
        <p>g.为遵守适用的法律法规、法院命令、相关政府机关的要求，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。</p>
        <p>您同意免除上述个人信息的接收和/或使用方在按照本声明所述情形下进行信息分享、转让和披露、使用而导致的或可能导致的所有索赔、责任和损失。</p>
        <dev class="f-w f-16">四、我们如何存储和传输个人信息</dev>
        <p>根据《网络安全法》的规定，我们会对您的浏览日志信息保存至少6个月；对于您的其他个人信息，我们仅在为您提供{{ name }}相关服务之目的所必需的期间内保留，您发布的信息、评论、交易数据相关信息，在您未撤回、删除或未注销账号期间，我们会保留相关信息。在您注销账号时，我们将停止使用并删除上述信息。
        </p>
        <p>上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。境外管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。
        </p>
        <dev class="f-w f-16">五、我们如何保护个人信息的安全</dev>
        <p>5.1
            我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露、分享。我们将使用加密技术（例如SSL）、匿名化处理及相关合理可行的手段保护您的个人信息并使用安全保护机制防止您的个人信息遭到恶意攻击。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。如因我们的重大过失导致您的信息被非授权访问、公开披露、篡改、或毁坏，而导致您的合法权益受损，我们将承担相应的法律责任。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
        </p>
        <p>5.2
            在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
        </p>
        <p>5.3
            您知悉并理解，您在使用我们的服务过程中所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息透露给他人。
        </p>
        <p>5.4 适用例外</p>
        <p>您同意按本《隐私协议》所述的目的和方式来处理您的个人信息。服务可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。例如：您利用“分享”键将某些内容分享到我们的服务，或您利用第三方连线服务登录我们的服务。这些功能可能会收集您的相关信息（包括您的日志信息），并可能在您的电脑装置cookies，从而正常运行上述功能。
        </p>
        <p>我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站。
            该等第三方社交媒体或其他服务可能由相关的第三方或我们运营。只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。如您将信息通过上述渠道公开或共享，由此造成您的信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的信息。
        </p>
        <p>您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私协议的约束，您需要仔细阅读其条款。本《隐私协议》仅适用于我们所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。
        </p>
        <dev class="f-w f-16">六、管理您的个人信息</dev>
        <p>6.1 查阅和访问个人账号信息</p>
        <p>您有权随时查阅和访问您向我们提供的个人信息，具体方式为登录{{ name }}网站并进入“https://www.motortime.com”页面；在登录{{ name }}App的状态下，通过“我的”——点击“用户信息”——在“用户信息”中查看。
        </p>
        <p>您必须对您的账号和验证码信息负有保密义务。任何情况下，请小心妥善保管。</p>
        <p>6.2 修改、删除个人信息</p>
        <p>6.2.1
            我们鼓励您更新和修改您的信息以使其更准确有效。个人信息的查询和修改，您需要先登录{{ name }}网站，然后进入“https://www.motortime.com”页面，或在登录{{ name }}App的状态下通过“我的”——点击“用户信息”——在“用户信息”中完成查询和修改您的个人信息操作，并获取您的个人信息副本。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。我们会采取适当的控制措施，避免验证身份过程中造成的个人信息泄露。
        </p>
        <p>6.2.2
            我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。如您无法通过上述方式访问、更新、更正或删除您的个人信息，或您需要访问、更新、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息，或您认为我们存在任何违反法律法规或本隐私协议的行为，我们将在不超过【三十天】或法律法规规定期限内作出答复。
        </p>
        <p>6.3 注销账号</p>
        <p>在符合{{ name }}单项服务的服务协议约定条件及国家相关法律法规规定的情况下，您的该项{{ name }}服务账号可能被注销或删除。当账号注销或被删除后，与该账号相关的、该单项服务项下的全部服务资料和数据将依照单项服务的服务协议约定删除或处理。
        </p>
        <p>6.4 改变或撤回授权</p>
        <p>您总是可以选择是否披露信息。有些信息是使用{{ name }}服务所必需的，但大多数其他信息的提供是由您决定的。您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集信息的范围或撤回您的授权。
        </p>
        <p>6.4.1 改变或撤回敏感权限设置</p>
        <p>您可以在设备本身操作系统中关闭地理位置权限、摄像头、麦克风、相册权限改变同意范围或撤回您的授权。撤回授权后我们将不再收集与这些权限相关信息。</p>
        <p>当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。</p>
        <p>6.5 访问隐私协议</p>
        <p>a、{{ name }}App：您可以在注册页面，或者在“我的”——点击——“关于{{ name }}“查看本隐私协议的全部内容。</p>
        <p>b、{{ name }}网站：你可以通过汽车网站首页最底部的“隐私协议”链接，访问隐私协议；您也可以直接从该链接查看：https://www.motortime.com/</p>
        <dev class="f-w f-16">七、未成年人信息安全的特别约定</dev>
        <p>我们期望父母或监护人指导未成年人使用我们的服务。如您为未成年人，建议请您的父母或监护人阅读本政策，并在征得您父母或监护人同意的前提下使用我们的服务或向我们提供您的信息。如您的监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。{{ name }}将根据国家相关法律法规的规定保护未成年人的个人信息的保密性及安全性。
        </p>
        <dev class="f-w f-16">八、修订和通知</dev>
        <p>我们可能适时修改本《隐私协议》的条款，该等修改构成本《隐私协议》的一部分。对于重大变更，我们会在应用程序启动弹框的形式发布相关公告，您可以选择停止使用{{ name }}服务；在该种情况下，如您仍然继续使用{{ name }}服务，即表示同意受经修订的本《隐私协议》的约束。
        </p>
        <p>任何修改都会将您的满意度置于首位。我们鼓励您在每次使用{{ name }}服务时都查阅我们的隐私协议。</p>
        <dev class="f-w f-16">九、联系我们</dev>
        <p>公司名称：北京御城铭翼网络科技有限公司；</p>
        <p>注册地址： 北京市朝阳区东直门外大街26号楼10层1006；</p>
        <p>常用办公地址： 北京市朝阳区东直门外大街26号楼10层1006；</p>
        <p>个人信息保护相关负责人联系方式：010-84425181</p>
        <p>联系邮箱：kefu@motortime.com</p>
    </div> -->
</div>
</template>

<script>
    import content from '../../api/content';
    export default {
      data () {
        return {
            info:'',
            name: '富士范儿'
        }
    },
    created () {
        this.$store.commit('param/show', false)
        this.$appService.isShowReturn({state: true})
        this.getAgreement(9)
    },
    methods: {
        getAgreement(id){
          content.getAgreement({id:id}).then(res => {
            this.info=res.data.data
        })
      },
  }
};
</script>

<style lang="scss">
    .agreement_page {
      padding: 10px;
  }
</style>
